/* Copyright 2015-2020 VMware, Inc. All rights reserved. -- VMware Confidential */

/**
 * This file must come first.
 */
window.h5 = window.h5 || {};
window.h5.uiLib = window.h5.uiLib || {};
window.h5.actions = window.h5.actions || {};
window.h5.dragAndDropValidationMethods = window.h5.dragAndDropValidationMethods || {};
window.h5.listViewSelectedItemIdProperty = "lvSelectedItemId";
window.h5.resourcesDirectory = "resources11561153";

// TEMPORARY SETUP of global h5.ngMigrationEnabled flag for all Angular migration work
// This global approach was chosen for its simplicity and minimal code churn.
// h5.ngMigrationEnabled will be removed when the migration is fully done!

/*jshint devel:true */
h5.ngMigrationEnabled = true; // sets the default value for ngMigrationEnabled

if (h5.configuration && h5.configuration.featureStates && h5.configuration.featureStates.h5uiNgMigration) {

   h5.ngMigrationEnabled = h5.configuration.featureStates.h5uiNgMigration === "ENABLED";
}

if (h5.ngMigrationEnabled) {
   // Use localstorage to let dev switch quickly without restarting server
   if (window.localStorage.getItem("ngMigrationEnabled") === "false") {
      h5.ngMigrationEnabled = false;
      console.warn("**** ngMigrationEnabled is false in localstorage ****");
   } else {
      window.localStorage.setItem("ngMigrationEnabled", "true");
   }
}

// Some AngularJS tests cannot run with `ngMigrationEnabled` and there is no point in fixing them.
// Read: https://jira.eng.vmware.com/browse/VSUIR-930 for more details"
if (typeof window.__karma__ !== "undefined") {
   window.localStorage.setItem("ngMigrationEnabled", (h5.ngMigrationEnabled = false).toString());
}

// Special function to extract and re-use legacy controller inside upgraded components
h5.ngMigrationResolveController = function (moduleName, controllerName) {
   var result = moduleName["_invokeQueue"].filter(function (assembly) {
      return assembly[0] === "$controllerProvider" && assembly[2][0] === controllerName;
   });
   if (result.length === 0) {
      console.error("Cannot find controller " + controllerName);
      return null;
   }
   return result[0][2][1];
};

// Default controller assigned to zng1 wrappers of templates that don't define ng-controller.
h5.ngMigrationDefaultCompatibilityController = function() {
   var controllerCtor = function(i18nService, $scope){
      $scope.i18n = i18nService.getString;
   };
   controllerCtor.$inject = ['i18nService', '$scope'];
   return controllerCtor;

};

/**
 * @ngdoc overview
 * @name com.vmware.platform.ui
 * @module com.vmware.platform.ui
 *
 * @description
 *    # com.vmware.platform.ui
 *    This module contains various utility services for fetching and mutating objects
 *    and data, navigating, localization and other common tasks.
 *
 *    <mark style="background: #FA8072">Many of the APIs in this module are still
 *    candidate only and subject to change. Send feedback to h5-reviews@vmware.com.</mark>
 */
window.h5.uiLib.angularModule = angular
      .module('com.vmware.platform.ui', [
            'ngAria',
            'ngCookies',
            'vui.angular',
            'kendo.directives',
            'angulartics',
            'angulartics.piwik',
            'clarity-bridge', // Angular2 based Clarity
            'ui.sortable'
         ]
      )
      .config([
         'vuiModalServiceProvider', 'vuiDialogServiceProvider', 'vuiWizardServiceProvider',
         function(vuiModalServiceProvider, vuiDialogServiceProvider, vuiWizardServiceProvider) {
            vuiModalServiceProvider.setDefaultConfig({
               destroyOnHide: true,
               destroyOuterScope: true
            });

            vuiDialogServiceProvider.setDefaultConfig({
               destroyOnHide: true,
               destroyOuterScope: true
            });
            vuiDialogServiceProvider.setDefaultDialogOptions({
               maximizable: false,
               resizable: false,
               draggable: true,
               resizeMinWidth: 320,
               resizeMinHeight: 320
            });

            vuiWizardServiceProvider.setDefaultConfig({
               destroyOnHide: true,
               destroyOuterScope: true
            });
            vuiWizardServiceProvider.setDefaultWizardOptions({
               maximizable: true,
               resizable: true,
               draggable: true,
               resizeMinWidth: 700,
               resizeMinHeight: 420,
               closeOnEsc: true
            });
         }])
      .config([
         '$compileProvider', '$httpProvider', '$locationProvider',
               function ($compileProvider, $httpProvider, $locationProvider) {
            $compileProvider.aHrefSanitizationWhitelist(
                  /^\s*((https?|ftp|mailto|tel|file|vmrc):|(javascript:((void\(0\))?;?|(\/{2})))$)/);
            $compileProvider.debugInfoEnabled(h5.debug);

            $httpProvider.defaults.xsrfCookieName = h5.xsrfCookieName;
            $httpProvider.defaults.xsrfHeaderName = h5.xsrfHeaderName;

            // Disables the compilation of directives on comments.
            // Results in a compilation performance gain.
            $compileProvider.commentDirectivesEnabled(false);
            // Disables the compilation of directives on element classes.
            // Results in a compilation performance gain.
            $compileProvider.cssClassDirectivesEnabled(false);

            // Required for Angular router
            if (window.h5.ngMigrationEnabled) {
               $locationProvider.html5Mode({
                  enabled: true
               });
            }
         }])
      .config(['$qProvider', function($qProvider) {
         // Possibly unhandled rejected promises will be logged to the
         // $exceptionHandler. Normally, that means that an error will be
         // logged to the console, but in tests $exceptionHandler will
         // (by default) re-throw any exceptions.
         // Tests that are affected by this change.
         // Adding this config option to keep 1.5 - 1.6 compatibility.
         // https://docs.angularjs.org/guide/migration#migrate1.5to1.6-ng-services-$q
         $qProvider.errorOnUnhandledRejections(false);
      }])
      .config(['$locationProvider', function ($locationProvider) {
         // Angular 1.6 introduces '!' as default hash prefix.
         // Adding this config option to keep 1.5 - 1.6 compatibility.
         // https://docs.angularjs.org/guide/migration#commit-aa077e8
         $locationProvider.hashPrefix('');
      }])
      .directive('input', function() {
         // Added for backward compatibility between Angular 1.5 & 1.6
         // https://docs.angularjs.org/guide/migration#migrate1.5to1.6-ng-directives-input%5Bnumber%5D
         return {
            restrict: 'E',
            require: '?ngModel',
            link: function (scope, elem, attrs, ngModelCtrl) {
               // ...that are of type "number" and have `ngModel`...
               if ((attrs.type === 'number') && ngModelCtrl) {
                  // ...remove the `step` validator.
                  delete ngModelCtrl.$validators.step;
               }
            }
         };
      })
      .run(['$rootScope', 'i18nService', '$cookies', 'vuiLocalizationService',
         function ($rootScope, i18nService, $cookies, vuiLocalizationService) {
         // Adding Language Resources to h5 global variable and $rootScope.
         h5.i18n.getString = i18nService.getString;
         angular.extend($rootScope, {
            i18n: i18nService.getString
         });

         vuiLocalizationService.set("navigationTree", i18nService.getString("CommonUi", "wizard.navigationTree.label"));
         vuiLocalizationService.set("alertCloseText", i18nService.getString("CommonUi", "clarity.i18n.alertCloseButtonAriaLabel"));

         jQuery.ajaxPrefilter(function (options, originalOptions, jqXHR) {
            var xsrfCookie = $cookies.get(h5.xsrfCookieName);
            if (xsrfCookie) {
               jqXHR.setRequestHeader(h5.xsrfHeaderName, xsrfCookie);
            }
         });
         }])
      // replaces initialization once performed by now deleted `MainTemplateController.js`
      .run(['$rootScope', '$http',
         function ($rootScope, $http) {

            // Debug function to dump pending http requests
            // system test util: `WebClientBaseView.java waitForRefreshButton()` given direct access AngularJS `$http`
            h5.__getPendingHttpRequests = function getPendingHttpRequests() {
               var pendingRequests = _.clone($http.pendingRequests);
               var jqueryRequests = _.clone(pendingJqueryRequests);
               var xhrRequests = _.clone(pendingXhrs);
               var i;
               for (i = 0; i < jqueryRequests.length; i++) {
                  var key = "jquery_" + i;
                  var obj = {};
                  obj[key] = jqueryRequests[i];
                  pendingRequests.push(obj);
               }

               var xhrKeys = _.keys(xhrRequests);
               for (i = 0; i < xhrKeys.length; i++) {
                  var key2 = "xhr:" + xhrKeys[i];
                  var obj2 = {};
                  obj2[key2] = xhrRequests[xhrKeys[i]];
                  pendingRequests.push(obj2);
               }

               return pendingRequests;
            };
         }]);

window.h5.h5main = window.h5.h5main || {};
window.h5.h5main.angularModule = angular.module('h5main',
      ['ngAnimate', 'com.vmware.platform.ui', 'angulartics', 'angulartics.piwik']);

var pendingJqueryRequests = [];
var pendingXhrs = {};

// context / right click disabled
if (!h5.debug) {
   if (h5.configuration && h5.configuration.configParams
         && h5.configuration.configParams["browser.context.menu"] === "false") {
      $(window).on('contextmenu', function() {
         return false;
      });
   } else {
      $(document).ready(function() {
         $('#applicationMenuContainer').on('contextmenu', function() {
            return false;
         });
      });
   }

   // Instrumentation to capture pending jQuery requests in addition to
   // pending Angular requests. h5.__getPendingHTTPRequests() is invoked by
   // the SystemTest automation.
   // See https://reviewboard.eng.vmware.com/r/1243537
   (function () {
      $(document).ready(function () {
         (function (open) {
            XMLHttpRequest.prototype.open = function (method, url, async, user, pass) {
               this.addEventListener("loadstart", function () {
                  pendingXhrs[url] = {'method': method};
               }, false);
               this.addEventListener("loadend", function () {
                  delete pendingXhrs[url];
               }, false);
               open.apply(this, arguments);
            };
         })(XMLHttpRequest.prototype.open);

         $(document).ajaxSend(function (evt, xhr, opts) {
            xhr.vmwopts = opts.url + " - " + opts.data;
            pendingJqueryRequests.push(xhr.vmwopts);
            xhr.always(function () {
               var idx = pendingJqueryRequests.indexOf(xhr.vmwopts);
               if (idx === -1) {
                  pendingJqueryRequests = [];
               }
               pendingJqueryRequests.splice(idx, 1);
            });
         });
      });
   })();
}
